import { render } from "./selfLessonCreate.vue?vue&type=template&id=178bced6&scoped=true"
import script from "./selfLessonCreate.vue?vue&type=script&lang=js"
export * from "./selfLessonCreate.vue?vue&type=script&lang=js"

import "./selfLessonCreate.vue?vue&type=style&index=0&id=178bced6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178bced6"]])

export default __exports__